module.exports = __webpack_public_path__ + "static/productpage-wireframe-m-b8fcb2567ade063688e74093ab79406d.png";